import React from 'react';

function ManagingWorkspacesContent() {
  return (
    <>
      <p>RepoPrompt allows you to save and manage workspaces, preserving your setup of open folders, selected files, instructions, and active prompts between sessions.</p>
      
      <h3>Workspace Management Options</h3>
      <p>The name of the currently open workspace is displayed in a dropdown menu at the top center of the window. Click this dropdown to access workspace management options:</p>
      
      <h3>Saving a Workspace</h3>
      <ol>
        <li>Set up your workspace with the desired folders, file selections, and prompts</li>
        <li>Click the workspace name dropdown at the top center</li>
        <li>Select "Save Workspace" to preserve the current state</li>
        <li>Your workspace configuration will be saved locally</li>
      </ol>
      
      <h3>Switching Between Workspaces</h3>
      <ol>
        <li>Click the workspace name dropdown</li>
        <li>Select a previously saved workspace from the list</li>
        <li>RepoPrompt will load that workspace configuration, including open folders, selected files, and active prompts</li>
      </ol>
      
      <h3>Closing a Workspace</h3>
      <p>To save and close the current workspace:</p>
      <ol>
        <li>Click the workspace name dropdown</li>
        <li>Select "Save & Exit Workspace"</li>
        <li>This will save the current state and return you to the initial screen</li>
      </ol>
      
      <h3>Managing Specific Folders</h3>
      <p>To close a specific root folder within the current workspace:</p>
      <ol>
        <li>Locate the folder in the file tree panel</li>
        <li>Click the "X" button next to its name</li>
        <li>The folder will be removed from the current workspace, but the workspace itself will remain open</li>
      </ol>
      
      <h3>Advanced Workspace Management</h3>
      <ol>
        <li>Click the workspace name dropdown</li>
        <li>Select "Manage Workspaces..."</li>
        <li>A modal will appear allowing you to rename, duplicate, or delete saved workspaces</li>
      </ol>
      
      <div className="tip-box">
        <strong>Tip:</strong> Create separate workspaces for different projects or tasks to quickly switch between them without losing your carefully curated file selections and prompts.
      </div>
    </>
  );
}

export default ManagingWorkspacesContent;